export const SAVE_RECEPTION_LAYOUT = 'SAVE_RECEPTION_LAYOUT';

export const saveReceptionLayout = (layout) => {
    return {
        type: SAVE_RECEPTION_LAYOUT,
        payload: layout,
    };
};
